import { IState } from '../../store';

export function isOfferInGageSelector(state: IState) {
  return !!state.offerData.agent?.bank;
}
